import { Component } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';

@Component({
	styles: [
		`
			.mat-icon {
				fill: rgba(0, 0, 0, 0.54);
				height: 16px;
				font-size: 16px;
				width: 16px;
				margin-left: 5px;
				verticle-align: middle;
			}
			.editable-column {
				font-weight: 700;
				font-size: 14px;
			}
		`
	],
	template: `
		<div class="editable-column">{{ params.displayName }} <mat-icon>edit</mat-icon></div>
	`
})
export class EditableHeaderComponent implements IHeaderAngularComp {
	public params: IHeaderParams;

	agInit(params: IHeaderParams): void {
		this.params = params;
	}
}
